export const getSearch = (state) => state.search;
export const getSearchResult = (state) => state.search.posts;
